module.exports = __webpack_public_path__ + "static/media/icon-upload-image.d07b4ae7.svg";